import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import standarImg from "../../../../assets/imgs/services/nationals/standar-background.jpg";
import Acordeon from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

function Standar() {
  const [tStandar] = useTranslation("standarPage");
  const [tSMetaData] = useTranslation("metaData");
  const idStandar = "41bd6b29-f877-4cfe-b40e-38d216751e64";
  const [textDescription, setTextDescription] = useState("");
  const [accordion1, setAccordion1] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [accordion3, setAccordion3] = useState("");

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[1]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[1]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idStandar}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      )
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion1(
            response.data.textWeb.text_es["02-Restricciones y Regulaciones"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
          setAccordion3(
            response.data.textWeb.text_es["04-Embalaje y Manejo Especial"]
              .content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion1(
            response.data.textWeb.text_us["02-Restrictions and Regulations"]
              .content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
          setAccordion3(
            response.data.textWeb.text_us["04-Packaging and Special Handling"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("standart.title")}</title>
        <meta name="description" content={tSMetaData("standart.description")} />
      </Helmet>
      <ImageHeader
        section={tStandar("header.section")}
        title={tStandar("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tStandar("description.content"))
        }
        quoteBtn={tStandar("header.quote-btn")}
        quoteProductID="btnQuoteTwelve"
        contactSales={tStandar("header.contact-sales")}
        contactProductID="btnContactTwelve"
        imgBackground={standarImg}
      />
      <Acordeon
        title={tStandar("accordion-1.title")}
        content={
          accordion1
            ? JSON.parse(accordion1)
            : JSON.parse(tStandar("accordion-1.content"))
        }
      />
      <div className="divider"></div>
      <Acordeon
        title={tStandar("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tStandar("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Acordeon
        title={tStandar("accordion-3.title")}
        content={
          accordion3
            ? JSON.parse(accordion3)
            : JSON.parse(tStandar("accordion-3.content"))
        }
      />
    </>
  );
}

export default Standar;
